/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Typography } from 'antd';

// Misc imports
import { useTranslation } from 'react-i18next';
import VariablesList from '../VariablesList';

const { Text } = Typography;

const SessionVariablesTab = ({ chatSession }) => {

  const { t } = useTranslation();

  const sortedVariables = [...chatSession.variables].sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="overflow-y-auto pl-2 pr-2 overflow-x-hidden" style={{ maxHeight: 590 }}>
      <Text strong className={'fs-lg mb-5'}>
        {t('Variables')}
      </Text>
      <VariablesList variables={sortedVariables}/>
    </div>
  );
};

SessionVariablesTab.propTypes = {
  chatSession: PropTypes.array
};

export default SessionVariablesTab;
